/**
 * Normalizes a URL pathname by replacing dynamic segments with placeholders. This allows for meaningful
 * pathname attributes in Otel metrics without introducing high cardinality problems.
 *
 * @param url The URL to normalize.
 * @returns The normalized pathname.
 */
export function normalizePathname(url: string): string {
    let pathname: string

    try {
        pathname = new URL(url).pathname
    } catch {
        // Handle fallback for relative paths (stripping query params and hash)
        pathname = url.split(/[?#]/, 1)[0] || '/'
    }

    return pathname
        .replace(/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi, '{uuid}') // UUIDs
        .replace(/\/\d+(?=\/|$)/g, '/{id}') // numeric segments
        .replace(/\d{4}-\d{2}-\d{2}/g, '{date}') // ISO dates
        .replace(/(\/gantt_single_room\/)([^/]+)/, '$1{room_code}') // edge case for room codes
}
